import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useSelector, useDispatch } from 'react-redux';

import actions from '@/actions';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';

const useEditorPath = () => {
  const dispatch = useDispatch();
  const commands = useSelector((state) => state.mission.json.commands);

  useUpdateEffect(() => {
    const path = getPath(commands);

    dispatch(actions.editor.loadPath(path));
  }, [commands]);
};

export default useEditorPath;

export const getPath = (commands) => {
  const path = [];
  commands.forEach((command) => {
    switch (command.type) {
      case 'navTakeoff':
        path.push(
          {
            id: `${command.id}/takeoff/start`,
            position: command.data.position,
            mslAltitude: 0, // 해수면 고도로 임의 지정하여 3D Map 경로 표시 시 지면에 닿아 보이도록 처리
          },
          {
            id: `${command.id}/takeoff/end`,
            position: command.data.position,
            mslAltitude: commands[0].data.elevation + command.data.altitude,
          }
        );
        break;

      case 'navLand':
        path.push(
          {
            id: `${command.id}/land/start`,
            position: command.data.position,
            mslAltitude: path.at(-1).mslAltitude,
          },
          {
            id: `${command.id}/land/end`,
            position: command.data.position,
            mslAltitude: 0, // 해수면 고도로 임의 지정하여 3D Map 경로 표시 시 지면에 닿아 보이도록 처리
          }
        );
        break;

      case 'navLoiterTime':
      case 'navLoiterToAlt':
      case 'navLoiterTurns':
      case 'navWaypoint':
        path.push({
          id: command.id,
          position: command.data.position,
          mslAltitude: commands[0].data.elevation + command.data.altitude,
        });
        break;

      case 'navReturnToLaunch':
        path.push(
          {
            id: `${command.id}/rtl/start`,
            position: commands[0].data.position,
            mslAltitude: path.at(-1).mslAltitude,
          },
          {
            id: `${command.id}/rtl/end`,
            position: commands[0].data.position,
            mslAltitude: 0, // 해수면 고도로 임의 지정하여 3D Map 경로 표시 시 지면에 닿아 보이도록 처리
          }
        );
        break;

      case 'cusSurvey':
        {
          const surveyCommand = getCommandForSurveySegment(command);
          surveyCommand.data.positions.forEach((position, index) => {
            let id = command.id;
            // 서베이 시작점
            if (index === 0) {
              id = `${id}/survey/start`;
            }
            // 서베이 종료점
            else if (index === surveyCommand.data.positions.length - 1) {
              id = `${id}/survey/end`;
            }
            // 서베이 중간점
            else {
              id = `${id}/survey/${index}`;
            }

            path.push({
              id,
              position,
              mslAltitude: commands[0].data.elevation + command.data.altitude,
            });
          });
        }
        break;

      default:
        break;
    }
  });
  return path;
};
